module.exports = __webpack_public_path__ + "img/rec-01.27a5efa4.jpg";